import { CheckCircle2, Loader2 } from "lucide-react";
import { PARTS } from "@/components/explain/constants";

/**
 * ExplainProgressRail — Iter84 extraction.
 *
 * 3-pill rail above the whitepaper content. Doubles as a Table of
 * Contents — tapping a completed pill smooth-scrolls to that part's
 * `<article>`. Disabled visual state while a part is still generating.
 */
export default function ExplainProgressRail({ parts, loadingPart, onJump }) {
  return (
    <div className="mt-5 grid grid-cols-3 gap-2" data-testid="explain-progress">
      {PARTS.map((p) => {
        const done = !!parts[String(p.n)];
        const active = loadingPart === p.n;
        const Icon = p.Icon;
        const clickable = done;
        return (
          <button
            key={p.n}
            type="button"
            onClick={() => clickable && onJump(p.n)}
            disabled={!clickable}
            aria-label={`Jump to Part ${p.n} · ${p.title}`}
            className={`px-3 py-2 rounded-lg border text-[11px] flex items-center gap-2 transition text-left ${
              done
                ? "border-[#00FF9D]/30 bg-[#00FF9D]/5 text-white/85 hover:border-[#00FF9D]/55 hover:bg-[#00FF9D]/10 cursor-pointer"
                : active
                  ? "border-[#0044FF]/40 bg-[#0044FF]/10 text-white cursor-wait"
                  : "border-white/10 bg-white/[0.02] text-white/40 cursor-not-allowed"
            }`}
            data-testid={`btn-jump-part-${p.n}`}
          >
            {done ? (
              <CheckCircle2 size={14} className="text-[#00FF9D] shrink-0" />
            ) : active ? (
              <Loader2 size={14} className="animate-spin shrink-0" />
            ) : (
              <Icon size={14} className={`${p.accent} shrink-0`} />
            )}
            <span className="truncate">Part {p.n} · {p.title}</span>
          </button>
        );
      })}
    </div>
  );
}
